<template>
  <div>
    <div class="font-weight-bold color-gray-7 mt-2 mb-3">
      Informaci&oacute;n de Localidad
    </div>
    <validation-provider
      v-if="
        !checkAccessLevel(accessLevel.centerCompany) &&
          !checkAccessLevel(accessLevel.location)
      "
      ref="locationVP"
      :mode="selectionChangeValMode"
      :rules="
        !profileData.userLocations
          ? ''
          : `locationsRequired:1,${mipeRole.accessLevel}`
      "
      v-slot="{ errors: locationErrors }"
    >
      <chips-selection
        ref="roleSelection"
        v-model="profileData.userLocations"
        @addingItem="addingLocation('locationEntryVO')"
        :selected-items-title="selectedLocationText"
        items-title-class="ml-2"
        :errors="locationErrors"
        :chips-config="chipsConfig"
        :disabled="readonly"
      >
        <template #selectionInputs>
          <validation-observer ref="locationEntryVO" disabled>
            <div
              class="form-group"
              v-if="
                checkAccessLevel(accessLevel.company) &&
                  (isFinanceUser || isRpUser)
              "
            >
              <label class="field-label">Compañía</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="companyDdl"
                  :options="positionOptionsAvailable"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedCompany"
                  @input="companyChanged"
                ></custom-drop-down>
              </validation-provider>
            </div>
            <div
              class="form-group"
              v-else-if="checkAccessLevel(accessLevel.center)"
            >
              <label class="field-label">Centro</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="centersDdl"
                  :options="serviceCenterOptionsAvailable"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedServiceCenter"
                ></custom-drop-down>
              </validation-provider>
            </div>
            <div
              class="form-group"
              v-else-if="checkAccessLevel(accessLevel.region)"
            >
              <label class="field-label">Región</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="regionsDdl"
                  :options="regionOptions"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedRegion"
                ></custom-drop-down>
              </validation-provider>
            </div>
            <div
              class="form-group"
              v-else-if="checkAccessLevel(accessLevel.district)"
            >
              <label class="field-label">Distrito</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="distritoDdl"
                  :options="districtOptions"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedDistrict"
                ></custom-drop-down>
              </validation-provider>
            </div>
            <div
              class="form-group"
              v-else-if="checkAccessLevel(accessLevel.municipality)"
            >
              <label class="field-label">Municipio</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="municipalityDdl"
                  :options="municipalityOptions"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedMunicipality"
                ></custom-drop-down>
              </validation-provider>
            </div>
            <div
              class="form-group"
              v-else-if="checkAccessLevel(accessLevel.school)"
            >
              <label class="field-label">Región</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="regionsFilteredDdl"
                  :options="regionOptions"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  v-model="selectedFilteredRegion"
                  custom-error-msg="Favor seleccione."
                  @input="regionsChanged"
                ></custom-drop-down>
              </validation-provider>

              <label class="field-label mt-1">Municipio</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="municipalityFilteredDdl"
                  :options="municipalityFilteredOptions"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  v-model="selectedFilteredMunicipality"
                  custom-error-msg="Favor seleccione."
                  @input="municipalityChanged"
                ></custom-drop-down>
              </validation-provider>

              <label class="field-label  mt-1">Escuela</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="schoolDdl"
                  :options="schoolOptionsAvailable"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedSchool"
                ></custom-drop-down>
              </validation-provider>
            </div>
            <div
              class="form-group"
              v-else-if="checkAccessLevel(accessLevel.healthRegion)"
            >
              <label class="field-label">Regiones de Salud</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="healthRegionDdl"
                  :options="healthRegionOptionsAvailable"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedHealthRegion"
                ></custom-drop-down>
              </validation-provider>
            </div>
          </validation-observer>
        </template>
      </chips-selection>
    </validation-provider>
    <validation-provider
      v-else-if="!checkAccessLevel(accessLevel.location)"
      ref="locationCenterCompanyAccessLevelVP"
      :mode="selectionChangeValMode"
      :rules="
        !profileData.userLocations
          ? ''
          : `locationsRequired:1,${mipeRole.accessLevel}`
      "
      v-slot="{ errors: locationErrors }"
    >
      <chips-selection
        ref="roleCenterCompanyLevelCompanySelection"
        v-model="profileData.userLocations"
        @addingItem="addingLocation('locationCenterCompanyLevelCompanyEntryVO')"
        selected-items-title="Compañías Seleccionadas"
        items-title-class="ml-2"
        filter-prop="companyId"
        :errors="locationErrors"
        :chips-config="[{ labelText: 'Compañía:', valueProp: 'companyName' }]"
        :disabled="readonly"
      >
        <template #selectionInputs>
          <validation-observer
            ref="locationCenterCompanyLevelCompanyEntryVO"
            disabled
          >
            <div class="form-group">
              <label class="field-label">Compañía</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="companyDdl"
                  :options="positionOptionsAvailable"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedCompany"
                ></custom-drop-down>
              </validation-provider>
            </div>
          </validation-observer>
        </template>
      </chips-selection>
      <chips-selection
        ref="roleCenterCompanyLevelCenterSelection"
        v-model="profileData.userLocations"
        @addingItem="addingLocation('locationCenterCompanyLevelCenterEntryVO')"
        selected-items-title="Centros Seleccionados"
        items-title-class="ml-2"
        filter-prop="centerId"
        :errors="locationErrors"
        :chips-config="[{ labelText: 'Centro:', valueProp: 'centerName' }]"
        :disabled="readonly"
      >
        <template #selectionInputs>
          <validation-observer
            ref="locationCenterCompanyLevelCenterEntryVO"
            disabled
          >
            <div class="form-group">
              <label class="field-label">Centro</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="centersDdl"
                  :options="serviceCenterOptionsAvailable"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedServiceCenter"
                ></custom-drop-down>
              </validation-provider>
            </div>
          </validation-observer>
        </template>
      </chips-selection>
    </validation-provider>
    <validation-provider
      ref="locationVP"
      :mode="selectionChangeValMode"
      :rules="'required'"
      v-slot="{ errors: locationErrors }"
      v-if="checkAccessLevel(accessLevel.location) && isFinanceUser"
    >
      <chips-selection
        ref="serviceLocationLevelCompanySelection"
        v-model="profileData.userLocations"
        @addingItem="addingLocation('serviceLocationLevelCompanyEntryVO')"
        selected-items-title="Lugar(es) de Servicio:"
        items-title-class="ml-2"
        :errors="locationErrors"
        :chips-config="[
          { labelText: 'Compañia:', valueProp: 'companyName' },
          { labelText: 'Lugar de Servicio:', valueProp: 'locationName' },
        ]"
        :disabled="readonly"
      >
        <template #selectionInputs>
          <validation-observer
            ref="serviceLocationLevelCompanyEntryVO"
            disabled
          >
            <div class="form-group">
              <label class="field-label">Compañía</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="companyDdl"
                  :options="companyOptions"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedCompany"
                  @input="companyChanged"
                ></custom-drop-down>
              </validation-provider>
            </div>

            <div class="form-group">
              <label class="field-label">Lugar de Servicio</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down
                  ref="serviceLocationDdl"
                  :options="serviceLocationOptionsAvailable"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccione."
                  v-model="selectedServiceLocation"
                ></custom-drop-down>
              </validation-provider>
            </div>
          </validation-observer>
        </template>
      </chips-selection>
    </validation-provider>
  </div>
</template>
<script>
import CustomDropDown from 'custom-drop-down';
import ChipsSelection from '@/components/common/ChipsSelection';
import applicationIds from '@/utils/constants/applicationIds';
import accessLevel from '@/utils/constants/accessLevel';
import { extend } from 'vee-validate';
import eduespService from '@/services/eduesp';
import { getUserCompanies } from '@/modules/userRequest/api';
import { getLocations, getAllLocations } from '@/modules/users/api';

extend('locationsRequired', {
  validate(selectedLocations, args) {
    return {
      required: true,
      valid:
        args.accessLevel !== accessLevel.none &&
        (selectedLocations?.length ?? 0) >= args.length,
    };
  },
  computesRequired: true,
  params: ['length', 'accessLevel'],
  message: 'Favor de seleccionar por lo menos una localidad.',
});

export default {
  name: 'MipeProfile',
  components: {
    CustomDropDown,
    ChipsSelection,
  },
  model: {
    prop: 'profile',
    event: 'profile-change',
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    profile: {
      type: Object,
      default: () => {},
    },
    isFinanceUser: {
      type: Boolean,
      default: () => false,
    },
    isRpUser: {
      type: Boolean,
      default: () => false,
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
    isLoginUserProvider: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      positionOptions: [],
      serviceCenterOptions: [],
      selectedServiceCenter: null,
      regionOptions: [],
      selectedRegion: null,
      selectedFilteredRegion: null,
      selectedFilteredMunicipality: null,
      districtOptions: [],
      selectedDistrict: null,
      municipalityOptions: [],
      municipalityFilteredOptions: [],
      selectedMunicipality: null,
      schoolOptions: [],
      selectedSchool: null,
      companyOptions: [],
      selectedCompany: null,
      serviceLocationOptions: [],
      selectedServiceLocation: null,
      chipsConfig: [],
      healthRegionOptions: [],
      selectedHealthRegion: null,
      selectedLocationText: null,
    };
  },
  computed: {
    profileData: {
      get() {
        return this.profile || {};
      },
      set(val) {
        this.$emit('profile-change', val);
      },
    },
    inEditMode() {
      return !!this.profileData.userId;
    },
    accessLevel() {
      return accessLevel;
    },
    isMipeUser() {
      return this.appId == applicationIds.mipe;
    },
    appId() {
      let applicationId = applicationIds.mipe;

      if (this.isFinanceUser) {
        applicationId = applicationIds.financePortal;
      }

      if (this.isRpUser) {
        applicationId = applicationIds.remProPortal;
      }

      return applicationId;
    },
    checkAccessLevel() {
      return (userAccessLevel) => this.mipeRole?.accessLevel == userAccessLevel;
    },
    mipeRole() {
      return this.user.roles.find(
        (r) => r.applicationId.toUpperCase() == this.appId
      );
    },
    positionOptionsAvailable() {
      const addedCompanyIds = this.profileData.userLocations.map(
        (x) => x.companyId
      );
      return this.companyOptions.filter((x) => {
        return !addedCompanyIds.includes(x.id);
      });
    },
    serviceLocationOptionsAvailable() {
      let addedServiceLocationIds = [];

      if (this.profileData.userLocations) {
        addedServiceLocationIds = this.profileData.userLocations.map(
          (x) => x.locationId
        );
      }

      return this.serviceLocationOptions.filter((x) => {
        return !addedServiceLocationIds.includes(x.id);
      });
    },
    schoolOptionsAvailable() {
      const addedSchoolIds = this.profileData.userLocations.map(
        (x) => x.schoolId
      );
      return this.schoolOptions.filter((x) => {
        return !addedSchoolIds.includes(x.id);
      });
    },
    serviceCenterOptionsAvailable() {
      const addedCenterIds = this.profileData.userLocations.map(
        (x) => x.centerId
      );
      return this.serviceCenterOptions.filter((x) => {
        return !addedCenterIds.includes(x.id);
      });
    },
    healthRegionOptionsAvailable() {
      const addedHealthRegionIds = this.profileData.userLocations.map(
        (x) => x.healthRegionId
      );
      return this.healthRegionOptions.filter(
        (x) => !addedHealthRegionIds.includes(x.id)
      );
    },
  },
  async mounted() {
    await this.setupLocations();
  },
  methods: {
    async regionsChanged() {
      this.municipalityFilteredOptions = await eduespService.getMunicipalities({
        regionId: this.selectedFilteredRegion.id,
      });
      this.selectedFilteredMunicipality = null;
      this.selectedSchool = null;
    },
    async municipalityChanged() {
      this.schoolOptions = await eduespService.getSchools({
        municipalityId: this.selectedFilteredMunicipality.id,
      });
      this.selectedSchool = null;
    },
    async companyChanged() {
      await this.getLocations();
    },
    async getLocations() {
      this.selectedServiceLocation = null;
      this.serviceLocationOptions = [];

      if (this.isLoginUserProvider) {
        const { data } = await getLocations();
        this.serviceLocationOptions = data;
      } else if (this.selectedCompany) {
        const { data } = await getAllLocations(this.selectedCompany.id);
        this.serviceLocationOptions = data;
      }
    },
    async setupLocations() {
      const userAccessLevel = this.mipeRole.accessLevel;
      this.removeLocationsByAccessLevel(userAccessLevel);
      await this.setupLocationSection(userAccessLevel);
    },
    async addingLocation(form) {
      const passed = await this.$refs[form].validate();
      if (passed) {
        const newLocation = this.getRoleLevelLocationData();
        this.$refs[form].reset();
        return newLocation;
      }
    },
    async setupLocationSection(userAccessLevel) {
      switch (userAccessLevel) {
        case this.accessLevel.municipality:
          this.selectedLocationText = 'Municipios Seleccionados';
          if (this.municipalityOptions.length == 0) {
            this.municipalityOptions = await eduespService.getMunicipalities();
          }
          this.chipsConfig = [
            { labelText: 'Municipio:', valueProp: 'municipalityName' },
          ];
          break;
        case this.accessLevel.region:
          this.selectedLocationText = 'Regiones Seleccionadas';
          if (this.regionOptions.length == 0) {
            this.regionOptions = await eduespService.getRegions();
          }
          this.chipsConfig = [
            { labelText: 'Región:', valueProp: 'regionName' },
          ];
          break;

        case this.accessLevel.center:
          this.selectedLocationText = 'Centros Seleccionados';
          if (this.serviceCenterOptions.length == 0) {
            this.serviceCenterOptions = (
              await eduespService.getServiceCentersKeyValue()
            ).data;
          }
          this.chipsConfig = [
            { labelText: 'Centro:', valueProp: 'centerName' },
          ];
          break;

        case this.accessLevel.school:
          this.selectedLocationText = 'Escuelas Seleccionadas';
          if (this.regionOptions.length == 0) {
            this.regionOptions = await eduespService.getRegions();
          }
          if (this.municipalityOptions.length == 0) {
            this.municipalityOptions = await eduespService.getMunicipalities();
          }
          this.chipsConfig.push({
            labelText: 'Región:',
            valueProp: 'regionName',
          });
          this.chipsConfig.push({
            labelText: 'Municipio:',
            valueProp: 'municipalityName',
          });
          this.chipsConfig.push({
            labelText: 'Escuela:',
            valueProp: 'schoolName',
          });
          break;
        case this.accessLevel.district:
          this.selectedLocationText = 'Distritos Seleccionados';
          if (this.districtOptions.length == 0) {
            this.districtOptions = await eduespService.getDistricts();
          }
          this.chipsConfig = [
            { labelText: 'Distrito:', valueProp: 'districtName' },
          ];
          break;
        case this.accessLevel.company:
          this.selectedLocationText = 'Compañías Seleccionadas';
          if (this.companyOptions.length == 0) {
            if (this.isLoginUserProvider)
              this.companyOptions = await getUserCompanies();
            else
              this.companyOptions = await eduespService.getCompanies(
                this.mipeRole.roleId
              );
          }
          this.getLocations();
          this.chipsConfig = [
            { labelText: 'Compañía:', valueProp: 'companyName' },
          ];
          break;
        case this.accessLevel.companySpecialist:
          this.selectedLocationText = 'Compañías Seleccionadas';
          if (this.companyOptions.length == 0) {
            this.companyOptions = await eduespService.getCompanies(
              this.mipeRole.roleId
            );
          }
          this.chipsConfig.push({
            labelText: 'Compañía:',
            valueProp: 'companyName',
          });
          this.chipsConfig.push({
            labelText: 'Municipio:',
            valueProp: 'municipalityName',
          });
          break;
        case this.accessLevel.healthRegion:
          this.selectedLocationText = 'Regiones de Salud Seleccionadas';
          if (this.healthRegionOptions.length == 0) {
            this.healthRegionOptions = await eduespService.getHealthRegions();
          }
          this.chipsConfig = [
            { labelText: 'Región de Salud:', valueProp: 'healthRegionName' },
          ];
          break;
        case this.accessLevel.centerCompany:
          if (this.companyOptions.length == 0) {
            if (this.isLoginUserProvider)
              this.companyOptions = await getUserCompanies();
            else
              this.companyOptions = await eduespService.getCompanies(
                this.mipeRole.roleId
              );
          }

          if (this.serviceCenterOptions.length == 0) {
            this.serviceCenterOptions = (
              await eduespService.getServiceCentersKeyValue()
            ).data;
          }

          break;
        case this.accessLevel.location:
          if (this.companyOptions.length == 0) {
            if (this.isLoginUserProvider)
              this.companyOptions = await getUserCompanies();
            else
              this.companyOptions = await eduespService.getCompanies(
                this.mipeRole.roleId
              );
          }
          this.getLocations();
          this.chipsConfig = [
            { labelText: 'Compañía:', valueProp: 'companyName' },
            {
              labelText: 'Lugar de Servicio:',
              valueProp: 'locationName',
            },
          ];
          break;
      }
    },
    getRoleLevelLocationData() {
      let result = { userId: this.user.userId };

      switch (this.mipeRole.accessLevel) {
        case this.accessLevel.municipality:
          result.municipalityId = this.selectedMunicipality.id;
          result.municipalityName = this.selectedMunicipality.name;
          this.selectedMunicipality = null;
          break;
        case this.accessLevel.region:
          result.regionId = this.selectedRegion.id;
          result.regionName = this.selectedRegion.name;
          this.selectedRegion = null;
          break;
        case this.accessLevel.center:
          result.centerId = this.selectedServiceCenter.id;
          result.centerName = this.selectedServiceCenter.name;
          this.selectedServiceCenter = null;
          break;
        case this.accessLevel.school:
          result.regionId = this.selectedFilteredRegion.id;
          result.regionName = this.selectedFilteredRegion.name;
          result.municipalityId = this.selectedFilteredMunicipality.id;
          result.municipalityName = this.selectedFilteredMunicipality.name;
          result.schoolId = this.selectedSchool.id;
          result.schoolName = this.selectedSchool.name;
          this.selectedFilteredRegion = null;
          this.selectedFilteredMunicipality = null;
          this.selectedSchool = null;
          break;
        case this.accessLevel.district:
          result.districtId = this.selectedDistrict.id;
          result.districtName = this.selectedDistrict.name;
          this.selectedDistrict = null;
          break;
        case this.accessLevel.company:
          if (this.selectedCompany) {
            result.companyId = this.selectedCompany.id;
            result.companyName = this.selectedCompany.name;
            this.selectedCompany = null;
          }

          break;
        case this.accessLevel.healthRegion:
          result.healthRegionId = this.selectedHealthRegion.id;
          result.healthRegionName = this.selectedHealthRegion.name;
          this.selectedHealthRegion = null;
          break;
        case this.accessLevel.centerCompany:
          if (this.selectedCompany) {
            result.companyId = this.selectedCompany.id;
            result.companyName = this.selectedCompany.name;
            this.selectedCompany = null;
          }

          if (this.selectedServiceCenter) {
            result.centerId = this.selectedServiceCenter.id;
            result.centerName = this.selectedServiceCenter.name;
            this.selectedServiceCenter = null;
          }

          break;
        case this.accessLevel.location:
          if (this.selectedCompany) {
            result.companyId = this.selectedCompany.id;
            result.companyName = this.selectedCompany.name;
            this.selectedCompany = null;
          }

          if (this.selectedServiceLocation) {
            result.locationId = this.selectedServiceLocation.id;
            result.locationName = this.selectedServiceLocation.name;
          }

          this.selectedServiceLocation = null;

          break;
      }

      return result;
    },
    removeLocations(mipeProfile) {
      while (mipeProfile.userLocations.length > 0) {
        mipeProfile.userLocations.pop();
      }
    },
    removeLocationsByAccessLevel(userAccessLevel) {
      let removeIndex = -1;
      do {
        removeIndex = this.profileData.userLocations.findIndex((l) => {
          switch (userAccessLevel) {
            case this.accessLevel.municipality:
              return !l.municipalityId;

            case this.accessLevel.region:
              return !l.regionId;

            case this.accessLevel.center:
              return !l.centerId;

            case this.accessLevel.school:
              return !l.schoolId;

            case this.accessLevel.district:
              return !l.districtId;

            case this.accessLevel.company:
              return !l.companyId;

            case this.accessLevel.companySpecialist:
              return !l.companyId;

            case this.accessLevel.healthRegion:
              return !l.healthRegionId;

            case this.accessLevel.centerCompany:
              return !l.centerId || !l.companyId;

            case this.accessLevel.location:
              return !l.locationId;
          }
        });
        if (removeIndex != -1) {
          this.profileData.userLocations.splice(removeIndex, 1);
        }
      } while (removeIndex != -1);
    },
    async save() {
      if (this.inEditMode) {
        const data = this.profileData;
        data.activeFlag = this.user.activeFlag ? '1' : '0';
        data.firstName = this.user.firstName;
        data.middleName = this.user.middleInitial;
        data.lastMaternalName = this.user.maternalLastName;
        data.lastPaternalName = this.user.paternalLastName;
        return eduespService.updateUserProfile(data);
      } else {
        this.profileData.userId = this.user.userId;
        return eduespService.createUserProfile(this.profileData);
      }
    },
    async validate() {
      return (await this.$refs.locationVP.validate()).valid;
    },
    selectionChangeValMode: () => {
      return {
        on: ['selectionChanged'],
      };
    },
  },
};
</script>
